<template>
  <div>
    <CardedTable :items="items" :headers="headers" :show_description="true">
      <template v-slot:[`item.is_read`]="{ item }">
        <v-chip small v-if="item.is_read == 0" color="green white--text"
          >new</v-chip
        >
        <span v-else>read</span>
      </template>

      <template v-slot:[`item.message`]="{ item }">
        <div class="d-inline-block text-truncate" style="max-width: 200px">
          {{ item.message }}
        </div>
      </template>

      <template v-slot:[`item.date`]="{ item }">
        {{ php_time_to_js_date_str(item.time_inserted) }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:description>
        <p class="text-left ml-4 mr-4">
          {{ unread_message }}
        </p>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "OwnerContactUsMessagesList",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => {
    return {
      _user: null,
      items: [],
      headers: [
        {
          text: "Email Address",
          align: "start",
          sortable: true,
          value: "email",
          filterable: true,
        },
        { text: "Business", value: "business.name", align: "start", filterable: true },
        { text: "Message", value: "message", align: "start", filterable: true },
        { text: "Status", value: "is_read", align: "center" },
        { text: "Date", value: "date", align: "center" },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_contact_messages(
        {
            owner_id: this._user.id
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.items = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors while loading contact us messages on owner");
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/owner/contact_us_messages/list/view/" + item.id);
    },
    php_time_to_js_date_str(tm) {
      return Utils.php_time_to_js_date_str(tm);
    },
  },
  computed: {
    unread_message() {
      var msg = "";
      var num = 0;
      for (let index = 0; index < this.items.length; index++) {
        const item = this.items[index];
        if (parseInt(item.is_read) == 0) {
          num = num + 1;
        }
      }
      if (num == 0 &&  this.items.length > 0) {
        msg = "All the messages have been read";
      } else if (num == 0 &&  this.items.length == 0) {
        msg = "You have not received any messages so far";
      } else if (num == 1) {
        msg = "There is only one unread message";
      } else {
        msg = "There are " + Utils.comma(num) + " unread messages";
      }
      return msg;
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    this.$emit("set-page-attributes", {
      title: "Contact Us Messages List",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Messages",
          disabled: false,
          href: "/owner/contact_us_messages",
        },
        {
          text: "List",
          disabled: true,
          href: "/owner/contact_us_messages/list",
        },
      ],
    });
    this.load_items();
  },
};
</script>